import { rootStore } from "../root";

export async function checkUserCancel(fc: () => Promise<void>) {
  try {
    if (rootStore.renderStore.processIsCancelled) {
      throw new Error("cancel process");
    } else await fc();
    rootStore.renderStore.setCurrentCompStepProgress(0);
    if (rootStore.renderStore.isCancelling){ // If we tried to cancel during the await function, only cancel now
      rootStore.renderStore.setProcessIsCancelled(true);
      rootStore.renderStore.setIsCancelling(false);
    }
  } catch (E) {
    console.log(E);
  }
}
